module.exports = __webpack_public_path__ + "img/sms.181514cc.png";